import CustomIcon from "../components/CustomIcon";
import GlobalStyles from "../components/GlobalStyles";
import { FontAwesome } from "@expo/vector-icons";
import * as React from "react";
import {
  StyleSheet,
  Text,
  View,
  Image,
  TouchableHighlight,
  TouchableOpacity,
  Platform,
  Dimensions
} from "react-native";
// import { ScrollView } from "react-native-gesture-handler"; a part of cleaner code
import { useSelector } from "react-redux";

import { loadUserData } from "../redux/actions/UserActions";
import {
  loadUserInvestDetails,
  loadInvestTransactions,
} from "../redux/actions/InvestActions";

import { useNavigation } from "@react-navigation/native";
import Ellipsis from "../components/Ellipsis";
import Colors from "../utilities/Color.js";
import { checkAndSetFUMNotification, loadNotificationsFromAPI } from "../redux/actions/NotificationActions";

import FeaturedOffers from "../components/buy/FeaturedOffers";
const myPlatform = Platform.OS

export default function MainMenuScreen() {
  // const dispatch = useDispatch();
  // CardActions(dispatch);
  const navigation = useNavigation();
  const MenuLogo = require("../assets/res/Aura_Alpha_Reversed_BlueBG.gif");
  const ShellLogo = require("../assets/images/shell/shellIcon.png");
  const userDataLoaded = useSelector((state) => state.user.userDataLoaded);
  const userWithdrawnLoaded = useSelector((state) => state.user.userWithdrawnLoaded);
  const userName = useSelector((state) => state.user.user.username);

  const refreshUserData = useSelector((state) => state.user.userRefresh);
  const firstRun = useSelector((state) => state.user.userFirstRun);
  const linkingMode = useSelector((state) => state.user.linkingMode);
  const debugFlag = useSelector((state) => state.uistate.debugMode);
  
  const win = Dimensions.get("window");

  //const hasNotifications = true;
  const hasNotifications = useSelector(
    (state) => state.notifications.unreadNotifications
  );
  const remoteNotificationsLoaded = useSelector(
    (state) => state.notifications.remoteNotificationsLoaded
  )

  const sparkle = require("../assets/res/sparkle_Alpha_LOOP.gif");

  const balance = useSelector((state) => state.user.userData.balance);
  const investedAmount = balance !== undefined ? balance.amountInvestedConfirmed : 0;
  const donatedAmount = balance !== undefined ? balance.amountDonated : 0;
  const withdrawnAmount = useSelector((state) => state.user.userAmountWithdrawn);

  var earnedAmount = 0;
  var earnedAmount = investedAmount - withdrawnAmount;
  var earnedAmount = Number.parseFloat(earnedAmount);
  

  // const investmentData = useSelector((state) => state.invest.transactionData);
  // const checkPendingTransaction = useSelector(
  //   (state) => state.invest.hasPendingTransaction
  // );
  // investmentData.forEach((val) => (earnedAmount += val.amount));


  // TODO: Load Invest Data
  React.useEffect(() => {
    if (refreshUserData) {
      loadUserData(userName);
    }
    if (firstRun) {
      navigation.navigate("FirstSigninScreen");
    } else if (linkingMode) {
      navigation.navigate("LinkingConfirmationScreen");
    } else {
      if (!remoteNotificationsLoaded) loadNotificationsFromAPI();
      if (investedAmount > 0) {
        checkAndSetFUMNotification();
      }
    }
  }, [
    firstRun,
    linkingMode,
    // userInvestID,
    // cacheDataLoaded,
    // transactionDataLoaded,
    investedAmount,
    refreshUserData,
    userName,
    remoteNotificationsLoaded
  ]);
  return (
    <View style={GlobalStyles.containerMB}>
      <View style={GlobalStyles.containerNmax}>
        <View style={styles.topHeaderContainer}>
          <View style={styles.mainMenuLogoContainer}>
            <View style={styles.topMenuLeftContainer}>
              <Image style={styles.mainMenuLogo} source={MenuLogo} />
            </View>
            <View style={styles.topMenuRightContainer}>
              <View style={styles.topDotContainer}>
              </View>
              <View style={styles.topTotalInvetmentContainer}>
              {userWithdrawnLoaded ? (
                <Text style={styles.topTotalInvetment} allowFontScaling={false}>
                  {'$'.concat(earnedAmount.toFixed(2))}
                </Text>
              ) : (
                <Text style={styles.topTotalInvetment} allowFontScaling={false}>
                  
                </Text>
              )}
              </View>
              <View style={styles.topIconsContainer}>
                <View style={styles.topSettingContainer}>
                  <OptionButton
                    icon="icon-menu-profile"
                    label="Settings"
                    onPress={() => navigation.navigate("Settings")}
                  />
                </View>
                <View style={styles.topDotContainer}>
                  {hasNotifications ? (
                    // <OptionButton
                    //   icon="icon-bell"
                    //   label="Notification"
                    //   onPress={() => {
                    //     navigation.navigate("NotificationListScreen");
                    //   }}
                    // />
                    // <FontAwesome name="circle" size={10} color={Colors.YELLOW} />
                    <></>
                  )
                    : (
                      <></>
                    )}
                </View>
              </View>
            </View>
          </View>
        </View>
        <View style={styles.bodyContainerFull}>
          <FeaturedOffers />
          {userDataLoaded ? (
            <View style={styles.contentContainer}>
              <OptionButton
                icon="icon-menu-buy"
                label="Buy"
                onPress={() => navigation.navigate("BuyOnline")}
              />
              <OptionButton
                icon="icon-menu-invest"
                label="Invest"
                onPress={() => navigation.navigate("InvestHome")}
              />
              <OptionButton
                icon="icon-menu-donate"
                label="Donate"
                onPress={() => navigation.navigate("DonateTypeSelectScreen")}
              />
              <View style={styles.leftButtonContainer}>
                <OptionButton
                  icon="icon-friends"
                  label="Invite Friends"
                  onPress={() => navigation.navigate("InviteFriends")}
                />
              </View>
            </View>
          ) : (
            <View style={styles.contentContainerLoading}>
              <Text style={styles.LoadingText}> </Text>
            </View>
          )}
        </View>
      </View>

      {/* must be uncommented to see shell stuff */}
      {(myPlatform != 'web' && userDataLoaded) || (win.width < 768 && userDataLoaded) ? (
        <View style={styles.shellFooterContainer}>
          <View style={styles.shellFooterCenteringContainer}>
            <View style={styles.shellFooterLeftContainer}>
              <View style={styles.fuelPartneContainer}>
                <Text
                  style={styles.fuelPartnerTextStyle}
                  allowFontScaling={false}
                >
                  Fuel Partner
                </Text>
              </View>
              <View style={styles.ShellLogoContainer}>
                <Image style={styles.ShellLogo} source={ShellLogo} />
              </View>
            </View>
            <View style={styles.shellFooterRightContainer}>
              <TouchableOpacity
                style={styles.shellButton}
                activeOpacity={0.5}
                onPress={() => navigation.navigate("PromotionalLanding")}
              >
                <View style={styles.shellFooterButtonContainer}>
                  <Text style={styles.redeemText} allowFontScaling={false}>
                    Redeem Fuel Cash Back
                  </Text>
                  <FontAwesome
                    style={styles.shellFooterArrowContainer}
                    name="angle-right"
                    size={25}
                    color={Colors.DARKGRAY}
                  />
                </View>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      ) : (
        <></>
      )}
    </View>
  );
}

function OptionButton({ icon, label, onPress, isLastOption }) {
  const navigation = useNavigation();
  const WhiteBarCodeIcon = require("../assets/images/white_BC_icon_lg.png");
  return (
    <View style={styles.optionButtonItem}>
      <View style={styles.optionButtonContainer}>
        <TouchableHighlight
          style={
            label != "Invite Friends"
              ? styles.option
              : {
                marginTop: 20,
                borderRadius: 30,
                borderWidth: 0,
                borderColor: "#fff",
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 0,
                paddingRight: 10,
              }
          }
          activeOpacity={0.5}
          underlayColor="rgb(0, 150, 255)"
          onPress={onPress}
        >
          <View style={styles.SubmitButtonStyle}>
            <View style={styles.optionIconContainer}>
              {icon == "icon-friends" ? null : (
                <CustomIcon
                  name={icon}
                  size={icon == "icon-menu-profile" ? 32 : 28}
                  color={label == "Notification" ? "rgba(255,204,0,0.99)" : "rgba(255,255,255,0.99)"}
                />
              )}
            </View>
            {label == "Invite Friends" ? (
              <View style={styles.optionTextRightContainer}>
                <View style={styles.inviteContainer}>
                  <Text
                    style={[styles.optionText, { fontSize: 14 }]}
                    allowFontScaling={false}
                  >
                    {label}{" "}
                  </Text>
                </View>
                <View style={styles.optionPromo}>
                  <Text style={styles.optionPromoText} allowFontScaling={false}>
                    $5
                  </Text>
                </View>
              </View>
            ) : (
              <View style={styles.optionTextContainer}>
                {(label != "Settings") & (label != "Notification") ? (
                  <Text style={styles.optionText} allowFontScaling={false}>
                    {label}
                  </Text>
                ) : null}
              </View>
            )}
            {(label != "Settings") &
              (label != "Invite Friends") &
              (label != "Notification") ? (
              <View style={styles.arrowContainer}>
                <FontAwesome
                  name="angle-right"
                  size={28}
                  color={Colors.WHITE}
                />
              </View>
            ) : null}
          </View>
        </TouchableHighlight>
      </View>
      <View style={styles.optionPromoIconContainer}>
        {/* {icon == "icon-friends" ? (
          <View style={styles.optionPromo}>
            <Text style={styles.optionPromoText}>$5</Text>
          </View>
        ) : (
          <></>
        )} */}
        {icon == "icon-settings" ? (
          <TouchableOpacity
            style={styles.cardiconContainer}
          // onPress={() => navigation.navigate("BarCode")}
          >
            <View style={styles.optionPromoCard}></View>
          </TouchableOpacity>
        ) : (
          <></>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  optionPromoCard: {
    top: -13,
  },
  whiteBarCodeIconST: {
    height: 50,
    width: 50,
  },
  optionButtonItem: {
    // flex:1,
    // backgroundColor: "red",
    // justifyContent:"space-evenlly"
    //paddingRight: 50,
    marginBottom: 15,
  },
  optionButtonContainer: {},
  optionPromoIconContainer: {
    justifyContent: "flex-start",
  },
  SubmitButtonStyle: {
    flexDirection: "row",
    justifyContent: "center",
    paddingRight: 10,
    paddingLeft: 10,
  },
  cardiconContainer: {
    left: 20,
  },
  arrowContainer: {
    justifyContent: "center",
    alignItems: "flex-end",
    paddingRight: 10,
  },
  optionTextContainer: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  optionTextRightContainer: {
    // flex: 1,
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "center",
  },
  inviteContainer: {
    paddingRight: 10,
  },
  optionPromo: {
    //left: 20,
    height: 30,
    width: 30,
    borderRadius: 25,
    backgroundColor: "#ffffff",
  },
  optionIconContainer: {
    // flex: 1,
    //marginRight: 12,
    paddingTop: 5,
    alignItems: "center",
    // backgroundColor: "yellow",
    width: 42,
  },
  optionPromoText: {
    paddingTop: 7,
    color: Colors.MIDBLUE,
    fontFamily: "montserrat-bold",
    fontSize: 12,
    alignSelf: "center",
  },
  LoadingText: {
    flex: 1,
    alignSelf: "center",
    paddingTop: 10,
    color: "#ffffff",
    fontFamily: "montserrat-bold",
    fontSize: 18,
  },
  bottomContainer: {
    // marginTop: 100,
  },
  contentContainer: {
    flex: 1,
    justifyContent: "space-around",
    maxHeight: 280,
    maxWidth: 500,
    marginTop: 30,
    paddingLeft: 20,
    paddingRight: 20,
  },
  contentContainerLoading: {
    flex: 1,
    width: "100%",
  },
  option: {
    //width: "70%",
    borderRadius: 30,
    borderWidth: 0,
    borderColor: "#fff",
    paddingTop: 5,
    paddingBottom: 10,
    paddingLeft: 0,
    paddingRight: 0,
    // marginLeft: 30,
    // marginBottom: 20,
    // height: 42
  },
  welcomeText: {
    fontSize: 20,
    color: "#ffffff",
    fontFamily: "montserrat-regular",
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 40,
  },
  optionText: {
    paddingTop: 3,
    marginLeft: 12,
    alignSelf: "flex-start",
    color: "#ffffff",
    fontFamily: "montserrat-semibold",
    fontSize: 18,
  },
  topHeaderContainer: {
    marginBottom: 28,
    paddingLeft: 40,
    paddingRight: 40,
  },
  mainMenuLogoContainer: {
    flexDirection: "row",
    paddingTop: 50,
  },
  topMenuRightContainer: {
    flex: 1,
    flexDirection: "row",
    paddingTop: 10,
    // marginRight:-20,
    // paddingRight: 7,
    justifyContent: "flex-end",
    //alignItems: "center",
    // backgroundColor:"pink"
  },
  topTotalInvetmentContainer: {
    paddingTop: 20,
    // alignItems: "center",
  },
  topIconsContainer: {
    flexDirection: "row",
    marginRight: 0
  },
  topSettingContainer: {
    paddingright: 0,
    //paddingTop: 5,
  },
  topDotContainer: {
    marginLeft: -15,
    marginTop: 10,
    // backgroundColor:"red"
  },
  topTotalInvetment: {
    fontFamily: "montserrat-bold",
    fontSize: 14,
    textAlign: "right",
    color: Colors.WHITE,
  },
  topMenuLeftContainer: {
    flex: 1,
    alignItems: "flex-start",
  },
  mainMenuLogo: {
    height: 70,
    width: 128,
  },
  shellFooterContainer: {
    // flexDirection: "row",
    backgroundColor: "#ffffff",
    height: 100,
    borderTopRightRadius: 40,
    //marginRight: 10,
    //marginBottom: -15,
    // marginTop: 130,
    maxWidth: "100%",
  },
  shellFooterCenteringContainer: {
    flex: 1,
    alignSelf: "center",
    flexDirection: "row",
    maxWidth: 450,
    width: "100%"
  },
  shellFooterLeftContainer: {
    flex: 4,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  fuelPartneContainer: {
    marginTop: 15,
    marginBottom: -25,
  },
  fuelPartnerTextStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "center",
    color: "#757575",
    fontSize: 11,
  },
  shellFooterRightContainer: {
    flex: 6,
    flexDirection: "row",
    justifyContent: "flex-end",
    //backgroundColor: "#00ff00"
  },
  shellFooterArrowContainer: {
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    marginLeft: 17,
    marginRight: 17,
  },
  shellFooterButtonContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    marginRight: 20,
  },
  shellButton: {
    height: 30,
    alignSelf: "center",
    //justifyContent: "center",
    ///borderRadius: 20,
  },
  ShellLogoContainer: {
    flex: 1,
    justifyContent: "center",
  },
  fuelText: {
    color: "#36454F",
    fontSize: 15,
  },
  ShellLogo: {
    height: 26,
    width: 89,
    resizeMode: "contain",
  },
  redeemText: {
    color: Colors.DARKGRAY,
    fontSize: 12,
    fontFamily: "montserrat-medium",
  },
  sparkle: {
    position: "absolute",
    top: -4,
    right: 5,
    width: 19,
    height: 19,
  },
  upperSavingBoxContainer: {
    flexDirection: "row",
    paddingBottom: 4,
    paddingTop: 5,
    // backgroundColor:"pink"
  },
  totalInvetmentContainer: {
    flex: 10,
    padding: 5,
    paddingRight: 20,
  },
  donatedContainer: {
    flex: 5,
    padding: 5,
    borderLeftColor: Colors.LIGHTGRAY,
    borderLeftWidth: 1,
    paddingRight: 20,
    paddingTop: 16,
    // backgroundColor:"green"
  },
  lowerTopContainer: {
    // flex: 1,
    flexDirection: "row",
    paddingBottom: 12,
    paddingTop: 5,
  },
  transactionLeftContainer: {
    flex: 1,
    paddingLeft: 0,
    marginTop: 10,
  },
  transactionRightContainer: {
    flex: 1,
    alignItems: "flex-end",
    paddingRight: 20,
    marginTop: 10,
    // alignSelf: "center",
    // backgroundColor: "yellow"
  },
  AmountLG: {
    fontFamily: "montserrat-bold",
    fontSize: 30,
    textAlign: "right",
    marginBottom: 2,
    color: Colors.MIDBLUE,
  },
  Amount: {
    fontFamily: "montserrat-bold",
    fontSize: 24,
    textAlign: "left",
    marginBottom: 5,
    color: Colors.MIDGRAY,
  },
  AmountPending: {
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "right",
    marginBottom: 5,
    color: "#998FA2",
  },
  subText: {
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "right",
    color: "#333333",
  },
  subTextPending: {
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "right",
    color: Colors.DARKGRAY,
  },
  scrollView: {
    flex: 1,
    backgroundColor: Colors.WHITE,
  },

  investText: {
    // color: "#757575",
    color: "#757575",
    fontFamily: "montserrat-medium",
    textAlign: "left",
    fontSize: 12,
    lineHeight: 16,
    paddingLeft: 18,
  },
  topWhiteContainer: {
    borderColor: Colors.LIGHTGRAY,
    borderWidth: 1,
    borderRadius: 10,
    backgroundColor: Colors.WHITE,
  },
  amountBlock: {
    // flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: Colors.LIGHTGRAY,
    // paddingBottom: 40,
    // backgroundColor:"green",
    justifyContent: "center",
    minWidth: 280,
  },
  investBlock: {
    // backgroundColor: "green",
  },

  bodyContainerFull: {
    // flexDirection: "column",
    // paddingTop: 30,
    // paddingBottom: 30,
    flex: 1,
    paddingLeft: 25,
    paddingRight: 25,
    // backgroundColor: "pink"
  },
  TextStyleHeader: {
    color: "#ffffff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
    // paddingLeft: 30,
    // paddingRight: 30,
  },
  TextStyleBody: {
    color: "#000000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 14,
    paddingLeft: 30,
    paddingRight: 30,
    // paddingBottom: 20,
    // paddingTop: 10,
  },
  buttonContainer: {
    flexDirection: "row",
    width: "100%",
    paddingLeft: 10,
    paddingRight: 100,
  },
  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    // lineHeight: 14,
  },
  leftButtonContainer: {
    alignItems: "flex-end",
  },
});
